export default __webpack_public_path__ + "static/media/icon-practice.1fabf02f.svg";